import { Instance } from 'mobx-state-tree'
import { CommunityGameModelBase } from './CommunityGameModel.base'

/* The TypeScript type of an instance of CommunityGameModel */
export interface CommunityGameModelType extends Instance<typeof CommunityGameModel.Type> {}

/* A graphql query fragment builders for CommunityGameModel */
export {
  selectFromCommunityGame,
  communityGameModelPrimitives,
  CommunityGameModelSelector
} from './CommunityGameModel.base'

/**
 * CommunityGameModel
 */
export const CommunityGameModel = CommunityGameModelBase.actions((self) => ({
  // This is an auto-generated example action.
  log() {
    console.log(JSON.stringify(self))
  }
}))
